module.exports = __webpack_public_path__ + "static/media/transparent_image_new.e8dc72d2.png";